import { useQuery } from '@tanstack/react-query';
import { api } from '@/auth/api';
import type { DriverLocation } from '@breaker/shared-types';

/**
 * Latest location per driver across the whole fleet — one current position
 * per driver who has shared against this fleet's loads. Powers the
 * fleet-wide live map. Consumes the aggregate read:
 *
 *   GET /v1/fleets/:fleetId/drivers/locations/latest
 *
 * Polls on an interval so the map stays live as new pings land (today that's
 * manual shares; once background sharing exists this is the live feed). The
 * key is inlined to match the sibling load sub-resource hooks.
 */
export function useFleetLatestLocations(fleetId: string | null) {
  return useQuery({
    queryKey: ['fleets', fleetId ?? '', 'locations', 'latest'] as const,
    enabled: Boolean(fleetId),
    queryFn: () =>
      api<{ locations: DriverLocation[] }>(
        `/v1/fleets/${fleetId}/drivers/locations/latest`,
      ),
    select: (data) => data.locations,
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
  });
}
